import JshModule from '@core/scripts/helper/jsh-module';

do {
    const {moduleScope} = JshModule('teaser/video-poster');

    const defaultPoster = moduleScope?.getAttribute('data-poster-default');
    const overridePoster = moduleScope?.getAttribute('data-poster-override');

    let poster = defaultPoster;
    if (window.matchMedia('(min-width: 768px)').matches && overridePoster) {
        poster = overridePoster;
    }

    if (poster) {
        moduleScope.setAttribute('poster', poster);
    }
} while (document.querySelector('[jsh-module="teaser/video-poster"]') !== null);
